import { Player, useGameContext } from "GameContext";

import {
  useState,
  useEffect,
} from "react";

import { getRoleConstants } from "utils/game-information-constants";
export default function ReedHarvester(
) {


  return (
    <div className="pt-4">
      <label>Harvesting Machines</label>
      <div className="my-2 border-b border-black"/>
      <p>{`Harvesting Machine Costs: ${getRoleConstants("Reed Harvester", "public")?.staticCosts[0][0]}`}</p>
      <p>{`Operator Costs: ${getRoleConstants("Reed Harvester", "public")?.staticCosts[1][0]} (${getRoleConstants("Reed Harvester", "public")?.staticCosts[1][1]})`}</p>
      <br/>
    </div>
  )

}
